import { render, staticRenderFns } from "./map.vue?vue&type=template&id=85ca06a4&"
import script from "./map.vue?vue&type=script&lang=js&"
export * from "./map.vue?vue&type=script&lang=js&"
import style0 from "./map.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3027311980/src/shiny-map/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('85ca06a4', component.options)
    } else {
      api.reload('85ca06a4', component.options)
    }
    module.hot.accept("./map.vue?vue&type=template&id=85ca06a4&", function () {
      api.rerender('85ca06a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue2-google-maps/dist/components/map.vue"
export default component.exports